import { UPDATES } from './updates';
import { NOTICES } from './notices';
import { PRESS_RELEASES } from './pressReleases';

export { UPDATES, NOTICES, PRESS_RELEASES };

const DAY_MS = 24 * 60 * 60 * 1000;
export const UPDATE_NEW_DAYS = 14;

// 필터 칩은 이 순서로, 실제 업데이트에 쓰인 분야만 보인다.
export const UPDATE_CATEGORIES = [
  { id: 'saenggibu', label: '생기부' },
  { id: 'scoring', label: '서술형 채점' },
  { id: 'ppt', label: 'PPT' },
  { id: 'hwp', label: '한글 문서' },
  { id: 'chat', label: 'AI 채팅' },
  { id: 'quiz', label: '퀴즈·학습지' },
  { id: 'payment', label: '요금제·결제' },
  { id: 'event', label: '이벤트' },
  { id: 'etc', label: '기타 개선' },
];

export const HELP_TABS = [
  { id: 'updates', label: '업데이트' },
  { id: 'notice', label: '공지사항' },
  { id: 'newsroom', label: '뉴스룸' },
];

export const DEFAULT_HELP_TAB = 'updates';

export const normalizeHelpTab = (tab) => (
  HELP_TABS.some(item => item.id === tab) ? tab : DEFAULT_HELP_TAB
);

const ARTICLE_SOURCES = [
  { tab: 'updates', items: UPDATES },
  { tab: 'notice', items: NOTICES },
  { tab: 'newsroom', items: PRESS_RELEASES },
];

/** /help/notice/:id 는 세 목록이 같은 주소를 쓴다. 어느 탭의 글인지 함께 돌려준다. */
export const findHelpArticle = (id) => {
  if (!id) return null;
  for (const source of ARTICLE_SOURCES) {
    const item = source.items.find(entry => entry.id === id);
    if (item) return { tab: source.tab, item };
  }
  return null;
};

export const getUpdateCategoryLabel = (id) => (
  UPDATE_CATEGORIES.find(category => category.id === id)?.label || null
);

export const getUsedUpdateCategories = (items = UPDATES) => {
  const used = new Set(items.flatMap(item => item.categories || []));
  return UPDATE_CATEGORIES.filter(category => used.has(category.id));
};

export const normalizeUpdateCategory = (id, items = UPDATES) => (
  getUsedUpdateCategories(items).some(category => category.id === id) ? id : null
);

export const filterUpdatesByCategory = (items, categoryId) => (
  categoryId ? items.filter(item => (item.categories || []).includes(categoryId)) : items
);

// date는 KST 날짜('YYYY-MM-DD')다.
export const getKstDayStart = (dateString) => new Date(`${dateString}T00:00:00+09:00`).getTime();

export const isNewUpdate = (update, now = Date.now(), days = UPDATE_NEW_DAYS) => {
  const start = getKstDayStart(update?.date);
  const current = now instanceof Date ? now.getTime() : Number(now);
  if (!Number.isFinite(start) || !Number.isFinite(current)) return false;
  return current >= start && current < start + days * DAY_MS;
};

/** 목록이 최신순이므로 newer는 앞, older는 뒤의 글이다. */
export const getAdjacentUpdates = (id, items = UPDATES) => {
  const index = items.findIndex(item => item.id === id);
  if (index < 0) return { newer: null, older: null };
  return {
    newer: index > 0 ? items[index - 1] : null,
    older: index < items.length - 1 ? items[index + 1] : null,
  };
};
